var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVendors = function SvgVendors(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/24*24/informative/vendors"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M15.3271 1.55957C16.3376 1.55957 17.3184 1.9039 18.1074 2.53516L21.0254 4.86816C21.642 5.36149 22.0008 6.10879 22.001 6.89844V17.1104C22.0009 19.5679 20.0084 21.5604 17.5508 21.5605H6.4502C3.99251 21.5605 2.0001 19.568 2 17.1104V6.89844C2.00015 6.10876 2.35894 5.36149 2.97559 4.86816L5.89355 2.53516C6.68254 1.90398 7.66247 1.55963 8.67285 1.55957H15.3271ZM15.5225 6.75977V8.78516C15.5223 10.7318 13.9447 12.3094 11.998 12.3096C10.0513 12.3096 8.47281 10.7319 8.47266 8.78516V6.75977H3.50977C3.50392 6.80551 3.50002 6.85174 3.5 6.89844V17.1104C3.5001 18.7396 4.82094 20.0605 6.4502 20.0605H17.5508C19.1799 20.0604 20.5009 18.7395 20.501 17.1104V6.89844C20.501 6.85174 20.4971 6.80551 20.4912 6.75977H15.5225ZM9.97266 8.78516C9.97281 9.90346 10.8797 10.8096 11.998 10.8096C13.1163 10.8094 14.0223 9.90337 14.0225 8.78516V6.75977H9.97266V8.78516ZM8.67285 3.05957C8.00305 3.05963 7.35311 3.28763 6.83008 3.70605L4.88867 5.25977H19.1123L17.1709 3.70605C16.6478 3.28758 15.997 3.05957 15.3271 3.05957H8.67285Z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVendors);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "vendors.61067807a033b03d478424aadfa4e74b.svg";